'use client';

//* Components
import PolicyChangesTemplate from '../../_sections/PolicyChanges';

const TermsOfUseTemplate = ({ pageData }) => {
	return (
		<PolicyChangesTemplate
			pageData={pageData}
			name='terms'
		/>
	);
};

export default TermsOfUseTemplate;
